import React from "react";
import { formatNumber } from "utils/currencyFormat";
import { BtnInPhieuThanhLy } from "components/DanhSachThanhLy/ChucNang/InPhieuThanhLy/BtnInPhieuThanhLy";
import { getDate } from "utils/formatDate";
import { BtnChiTietKhachhang } from "./ChiTietKhachHang/BtnChiTietKhachhang";
import { BtnChiTietHopDong } from "./ChiTietHopDong/BtnChiTietHopDong";
import { BtnChiTietTaiSan } from "./ChiTietTaiSan/BtnChiTietTaiSan";
export const ContentTable = ({ listDanhSachFull, quyenDaDoc }) => {
  return listDanhSachFull.map((item, index) => (
    <div
      className="custom-table-row"
      // style={{ border: "none" }}
      key={"item" + 1}
    >
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper color7">
          <p className="text-center">{item.STT}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-9-sm">
        <span className="mobile-column-name">Thời gian</span>
        <div className="center-wrapper color7">
          <p className="text-center word-break">{getDate(item.ThoiGian)}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-13 flex-basis-13-sm">
        <span className="mobile-column-name">Mã</span>
        <div className="center-wrapper color7">
          <p className="text-center word-break">{item.ThanhLyCode}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-13 flex-basis-12-6-sm">
        <span className="mobile-column-name">Tên khách hàng</span>
        <div className="center-wrapper color7">
          <p className="text-left color-xanh-bold">
            {/* <BtnChiTietKhachhang item={item} /> */}
            {item.TenKhachhang}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-18 flex-basis-16-sm">
        <span className="mobile-column-name">Tên tài sản</span>
        <div className="center-wrapper color7">
          <p className="text-left">
            <BtnChiTietTaiSan item={item} />
            <br />
            {item.TenTaiSan}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
        <span className="mobile-column-name">Mã hợp đồng</span>
        <div className="center-wrapper color7">
          <p className="text-center">
            <BtnChiTietHopDong item={item} />
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-12-8-sm">
        <span className="mobile-column-name">Tiền thanh lý</span>
        <div className="center-wrapper ">
          <p className="text-right color-do">
            {formatNumber(item.TienThanhLy)}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-13-sm">
        <span className="mobile-column-name">Chênh lệch</span>
        <div className="center-wrapper">
          <p className="text-right">
            {" "}
            <span className=" color-cam">{formatNumber(item.ChenhLech)}</span>
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-11 flex-basis-7-6-sm reponsive-cell-v2">
        <div className="center-wrapper color7">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <BtnInPhieuThanhLy thanhLyId={item.ThanhLyID} />
          </div>
        </div>
      </div>
    </div>
  ));
};
